/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
/// <summary>
/// メニューアイテムの基本
/// </summary>
export class MenuItemBase {

    /// <summary>
    /// コンストラクタ
    /// </summary>
    public constructor (
        menuItemID?: number
        , description?: string
        , disabled?: boolean
        , checked?: boolean
        , childMenuItem?: Array<MenuItemBase>
    ) {
        if (undefined != menuItemID) {
            this.menuItemID = menuItemID;
        }
        if (undefined != description) {
            this.description = description;
        }
        if (undefined != disabled) {
            this.disabled = disabled;
        }
        if (undefined != checked) {
            this.checked = checked;
        }
        if (undefined != childMenuItem) {
            this.childMenuItem = childMenuItem;
        }
    }

    /// <summary>
    /// メニューアイテムのID クリック時にこのIDを元に判定を行うため、リスト内で一意になるように作成すること
    /// </summary>
    public menuItemID = 0;

    /// <summary>
    /// サブメニュー ★OperationMenu: 現時点ではサブメニューは1階層までしか対応しておりません★
    ///              ★2階層目以降は、"@components\ListMenu\OperationMenu.vue"への実装が必要です。
    ///              ★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★★
    ///              ★SelectMenu : 現時点ではサブメニュは対応しておりません。★
    ///              ★サブメニューを使用するには、"@components\ListMenu\SelectMenu.vue"への実装が必要です。
    /// </summary>
    public childMenuItem = new Array<MenuItemBase>();

    /// <summary>
    /// メニュー名称
    /// </summary>
    public description = "";

    /// <summary>
    /// メニューの押下(有効・無効)
    /// </summary>
    public disabled = false;

    /// <summary>
    /// メニューの選択(選択・非選択)
    /// </summary>
    public checked = false;
}

/* Copyright (c)2023 Sky Co., LTD. All rights reserved. */
